import { processTypes } from '@domain/constants';
import { Branding, LayoutOptions } from '@domain/interfaces';

const detectLayoutType: (branding: Branding | null) => LayoutOptions = (
  branding,
) => {
  if (branding && branding.objectType === processTypes.Schadegarant) {
    return 'SG';
  }
  if (branding && branding.objectType === processTypes.DealerSaas) {
    return 'dealerSaas';
  }
    if (branding && branding.objectType === processTypes.IntakePlus) {
    return 'intakePlus';
  }
  return 'defaultLayout';
};


export default detectLayoutType;
